/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Setpointtemperatureecs2Inputs */



/**
* | output |
* | --- |
* | "ECS setpoint temperature" |
*
* @param {Br_History_Key_Setpointtemperatureecs2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_setpointtemperatureecs2 = /** @type {((inputs?: Br_History_Key_Setpointtemperatureecs2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Setpointtemperatureecs2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("ECS setpoint temperature")
	return /** @type {LocalizedString} */ ("Température de consigne ECS")
});
export { br_history_key_setpointtemperatureecs2 as "br_history_key_setpointTemperatureEcs" }